
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryVerticalLow as ObiBatteryVerticalLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-vertical-low.js';
 
 
 

 
 export const ObiBatteryVerticalLow = createComponent({
   react: React,
   tagName: 'obi-battery-vertical-low',
   elementClass: ObiBatteryVerticalLowElement,
   events: {
     
   }
  });
 
 